// Angular
import { Component} from '@angular/core';
import { BroadcastService, ModalService, ToasterType } from '@cv-invision/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ProductsService } from '../service/products.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
@Component({
	selector: 'cv-product-custom-action',
	templateUrl: './custom-action-products-cell.component.html',
	styleUrls: ['./custom-action-products-cell.component.scss']
})
export class CustomActionProductsCellComponent implements ICellRendererAngularComp {
	private atComponentDestroy = new Subject();
	public cellValue: any;

	constructor(
		private modalService: ModalService,
		private productService: ProductsService,
		private broadcastService: BroadcastService,
		private router: Router
	) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
	}

	/**
	 * edit Products
	 */
	onEditProducts(): void {
		this.router.navigate([`/global-configuration/product/edit/`, this.cellValue.id]);	
	}

	/**
	 * clone Products
	 */
	onCloneProducts(): void {
		this.modalService
					.customConfirm(
						`Clone`,
						`Do you want to clone ${this.cellValue.title}?`,
						'icon-warning fas fa-exclamation-circle'
					)
					.pipe(takeUntil(this.atComponentDestroy))
					.subscribe(result => {
						if (result.confirm === 'confirm') {
							this.productService.cloneProduct(this.cellValue.id).subscribe(
								(result) => {
									if(result.succeeded) {
										this.productService.setReloadListConfirmation({
											reloadList: true
										});
										this.broadcastService.broadcast({
											name: ToasterType.SUCCESS,
											event: { message: `The product ${this.cellValue.title} was cloned successfully` }
										});

										this.router.navigate([`/global-configuration/product/edit/`, result.productId]);
									}
								},
								(error) => {
									this.broadcastService.broadcast({
										name: ToasterType.ERROR,
										event: { error: 'Error occurred ' + error }
									});
								});
						}
					});
	}


	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
